import * as React from 'react';
import type { GatsbyBrowser } from 'gatsby';
import Layout from './src/components/layout';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
}) => {
  return <Layout>{element}</Layout>;
};

export const onInitialClientRender = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const loaderElement = document.getElementById("___loader");
    if (loaderElement) {
      loaderElement.style.display = "none";
    }
  });
}
